module.exports = __webpack_public_path__ + "static/img/qdwater.d42387f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handoff/clients/qdwater.png
// module id = +QI+
// module chunks = 1